/**
 * Self-service onboarding routes.
 *
 * /get-started            → create-account screen (AuthLayout shell)
 * /get-started/setup      → redirects to the first wizard step
 * /get-started/setup/:id  → "Create workspace" wizard step
 *
 * Always registered; each page is wrapped in `SelfServiceGate`, which reads
 * the server-driven gate (`/api/waitlist/self-service/status/`) and falls
 * through to the login redirect when the flow is disabled.
 */
import { Navigate } from 'react-router-dom';

import {
  FIRST_STEP_PATH,
  GET_STARTED_PATH,
  SETUP_BASE_PATH,
} from '@/lib/self-service/constants';
import GetStartedPage from '@/pages/get-started/GetStartedPage';
import SetupPage from '@/pages/get-started/SetupPage';

export const getStartedRoutes = [
  {
    path: GET_STARTED_PATH,
    element: <GetStartedPage />,
  },
  {
    path: SETUP_BASE_PATH,
    element: <Navigate to={FIRST_STEP_PATH} replace />,
  },
  {
    path: `${SETUP_BASE_PATH}/:stepId`,
    element: <SetupPage />,
  },
];
